// activate home page LBI transitions
if (window.jQuery) {
    window.jQuery(function ($) {
        var $html = $('html'),
            $body = $('body'),
            className = 'sticky-search',
            activeClassName = 'active',
            menuClassName = 'has-mobile-menu',
            blurOnScroll=true;

        function inputBlurred() {
            if (!$("body").hasClass("in-scroll")){
                setTimeout(function(){$body.removeClass(activeClassName);},10);
                return false;
            }
        }

        function cancelClicked(e) {
            if (e && e.preventDefault) e.preventDefault();

            var input = e && e.target && e.target.siblings ? e.target.siblings('.city-search').find('input[type=search]') : null,
                inputId = input ? input.attr('id') : null,
                isSticky = inputId && inputId.endsWith('-sticky');

            $('md-virtual-repeat-container').removeClass("in-scroll");
            $('body').removeClass("in-scroll");
            $("html").css({"overflow": ""});
            $("body").css({"overflow": ""});
            if (isSticky) {
                input.trigger('blur');
            } else {
                inputBlurred();
            }
            return false;
        }

        function inputFocused() {
            // $('md-virtual-repeat-container').removeClass("in-scroll");
            setTimeout(function(){$body.addClass(className).addClass(activeClassName);},10);
            blurOnScroll=true;
            return false
        }

        function toggleClass() {
            $html.toggleClass(menuClassName);
            var hasMenu = $html.hasClass(menuClassName);
            $body.toggleClass(className, hasMenu).toggleClass(activeClassName, false);
            setTimeout(scrollHandler, 300);
            return true;
        }

        function scrollHandler() {
            var hasClass = $body.hasClass(className),
                hasActiveClass = $body.hasClass(activeClassName),
                hasMenuClass = $html.hasClass(menuClassName),
                scrollTop = $(window).scrollTop(),
                height = 36;

            // TCT.debug('Top Navigation: scrollHandler', hasClass, scrollTop, height);

            if (scrollTop > height && !hasClass) {
                $body.addClass(className).removeClass(activeClassName);
            }

            if (!hasMenuClass && !hasActiveClass && scrollTop < height && hasClass) {
                $body.removeClass(className).removeClass(activeClassName);
            }
        }

        function inputScrollTop() {
            $('body.home').scrollTop($('main#home .flexWrap .location-selector').position().top - 2);
        }
        $('html.touchevents md-virtual-repeat-container .md-virtual-repeat-scroller').on("touchstart",function(ev){
            if (!$(ev.currentTarget.parentNode).hasClass("in-scroll")){
                $(ev.currentTarget.parentNode).addClass("in-scroll");
                $('body').addClass("in-scroll");
                $('md-autocomplete input').blur();
                $body.addClass(className).addClass(activeClassName);
                setTimeout(function(){
                    $("html").css({"overflow": "hidden"});
                    $("body").css({"overflow": "hidden"});
                    },100);
                blurOnScroll=false;

            }
            else if (blurOnScroll){
                $('md-autocomplete input').blur();
                setTimeout(function(){
                    $("html").css({"overflow": "hidden"});
                    $("body").css({"overflow": "hidden"});
                },100);
                blurOnScroll=false;
            }


        });

        $('.touchevents body.home').on('focus', '#auto-complete-location-inspiration, #auto-complete-location-inspiration-sticky', inputScrollTop);
        // window.addEventListener('scroll', scrollHandler, {passive: true});
        $body.on('focus', '#auto-complete-location-inspiration, #auto-complete-location-inspiration-sticky', inputFocused)
            .on('click tap', '#auto-complete-location-inspiration-cancel', cancelClicked)
            .on('click tap', 'md-autocomplete-wrap button', function(){setTimeout(inputFocused,20);})
            .on('blur', '#auto-complete-location-inspiration, #auto-complete-location-inspiration-sticky', inputBlurred)
    });
}